import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import {
  getLoanReportData,
  getSahaySubTypeList,
  getSahayTypeList,
  getSubSahayReportData,
} from "../../../../redux/features/AddService";
import { useSelector } from "react-redux";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
// import SahayMultiPleTableList from "./SahayMultiPleTableList";
import { useReactToPrint } from "react-to-print";
import { Autocomplete } from "@mui/material";
import PrintReport from "../../../../components/common/printReport/PrintReport";
import FileExcel from "../../../../components/common/excelSheet/FileExcel";
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import Pagination from "../../../../components/common/Pagination";
import { Api } from "../../../../config/Api";
import dataService from "../../../../config/DataService";
import moment from "moment";
import dayjs from "dayjs";

const familyIncomeAmountList = [
  { id: 1, ammount: "Less than 5 lakh" },
  { id: 2, ammount: "5 lakh or above" },
];

const electricBillAmountList = [
  { id: 1, ammount: "0 to 1000" },
  { id: 2, ammount: "1001 to 2500" },
  { id: 3, ammount: "2501 to 3500" },
  { id: 4, ammount: "3501 and Above" },
];

export default function LoanReport() {
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const location = PagesIndex.useLocation();
  const { getSubSahayReportDataList } = PagesIndex.useSelector(
    (state) => state?.admin
  );

  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [excel, setExcel] = useState([]);
  const [filterSubSahayName, setFilterSubSahayName] = useState("");
  const [filter, setFilter] = useState("");
  const [filterSubSahay, setFilterSubSahay] = useState("");
  const [filterSahay, setFilterSahay] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const [sahayTypeList, setSahayTypeList] = useState([]);
  const [sahaySubTypeList, setSahaySubTypeList] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [rowPerPage, setRowPerPage] = useState("25");
  const [filterReportData, setFilterReportData] = useState([]);
  const [filterFamilyIncome, setFilterFamilyIncome] = useState("");
  const [filterElectricityBill, setFilterElectricityBill] = useState("");
  const [selectDateData, setSelectDateData] = useState("");
  const [sortColumn, setSortColumn] = useState("DateOfLoan");
  const [sortDirection, setSortDirection] = useState("asc");
  // Print Reports
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handleSort = (column) => {
    const isAsc = sortColumn === column && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortColumn(column);

    const today = new Date(); // Get current date

    const sortedData = [...searchedData].sort((a, b) => {
      if (column === "DateOfLoan") {
        const dateA = new Date(a.DateOfLoan);
        const dateB = new Date(b.DateOfLoan);

        const diffA = Math.abs(today - dateA);
        const diffB = Math.abs(today - dateB);

        return isAsc ? diffA - diffB : diffB - diffA;
      }
      return 0;
    });

    setSearchedData(sortedData);
};


  // //Filter Data

  useEffect(() => {
    const filters = {
      FID: filter,
      Year: filterYear,
      SahayName: filterSahay,
      SubSahayName: filterSubSahay,
      familyIncome: filterFamilyIncome,
      electricityBill: filterElectricityBill,
      DateOfLoan:
        typeof selectDateData === "object"
          ? moment(selectDateData).format("YYYY-MM-DD")
          : selectDateData,
    };

    const filterData = data?.filter((ele) => {
      if (Object.values(filters).some(Boolean)) {
        return Object.entries(filters).every(([key, value]) => {
          if (!value) return true;
          return ele[key] == value;
        });
      } else {
        return true;
      }
    });

    setFilterReportData(filterData);
  }, [
    data,
    filter,
    filterYear,
    filterSahay,
    filterSubSahay,
    filterElectricityBill,
    filterFamilyIncome,
    selectDateData,
  ]);

  useEffect(() => {
    setSearchedData(filterReportData);
  }, [filterReportData]);

  // useEffect(() => {
  //   if (location?.state?.LoanDateData) {
  //     setSelectDateData(dayjs(location.state.LoanDateData));
  //   }
  // }, [location?.state?.LoanDateData]);

  const fileName = "Sahay Detail Sahay Wise CSV";
  useEffect(() => {
    const customHeadings = filterReportData?.map((item) => ({
      Fid: item?.FID,
      "Applicant name": item?.ApplicantName,
      "Sahay Name": item?.SahayName,
      "Sub Sahay Name": item?.SubSahayName,
      "Beneficiary Name": item?.BeneficiaryName,
      "Moholla Name": item?.MohollaName,
      Area: item?.Area,
      "Requested Sahay": item?.SahayAmount,
      "Approve Amount": item?.ApproveAmount,
      Year: item?.Year,
      "Application Date Received": item?.applicationReceiveDate,
      "Application Entered Date": item?.ApplicationEnteredDate,
      "Committee Approval Date": item?.committeeApprovalDate,
      "Filing Date": item?.formFillingDate,
      "Electricity Bill": item?.electricityBill,
      "Family Income": item?.familyIncome,
    }));

    setExcel(customHeadings);
  }, [filterReportData]);

  const requestSearch = (searched) => {
    if (!searched) return setSearchedData(filterReportData);

    setSearchedData(
      filterReportData?.filter(
        (item) =>
          item?.ApplicantName?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase()) ||
          item?.LoanAmount?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase()) ||
          item?.BeneficiaryName?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase())
      )
    );
  };

  //get Sub sahay list
  const getSahaySubTypeData = async (id) => {
    dispatch(getSahaySubTypeList(id)).then((res) => {
      if (res?.payload) {
        setSahaySubTypeList(res?.payload);
      } else {
        setSahaySubTypeList([]);
      }
    });
  };
  //Sahay Type list
  const fetchSahayTypeList = () => {
    dispatch(getSahayTypeList()).then((res) => {
      setSahayTypeList(res?.payload);
    });
  };

  useEffect(() => {
    fetchSahayTypeList();
    getSahaySubTypeData();
  }, []);

  useEffect(() => {
    dispatch(getLoanReportData()).then((res) => {
      if (res?.payload?.status == 200) {
        setData(res?.payload?.data);
        setFilterReportData(res?.payload?.data);
        setLoader(false);
      }
      setLoader(false);
    });
  }, []);

  //#region start view sahay application

  const handleSahayApplicationView = (viewdata) => {
    const updatedViewData = {
      ...viewdata,
      familyId: viewdata?.FID,
      prevRoute: location?.pathname,
    };
    navigate(`/${rollData}/sahay-report-view`, { state: updatedViewData });
  };

  //#region end view sahay application

  const { rollPermissionData } = useSelector((state) => state.admin);
  const rollPermissionNameData =
    rollPermissionData?.findData?.parentRoleName?.toLowerCase();

  const handleLoanView = (data) => {
    navigate(`/${rollData}/loan-report-Installment-view`, {
      state: {
        loanInstallment: data?.loanInstallment,
        LoanDateData: selectDateData,
      },
    });
  };
  if (
    rollPermissionData?.permissionArray?.includes("Loan Report_view") ||
    rollPermissionNameData === "admin"
  ) {
  } else {
    navigate(`/${rollData}/sahay-application`);
  }

  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box className="title-header">
                <Index.Box className="title-header-flex res-title-header-flex">
                  <Index.Box className="plus-hidden-show-mobile">
                    <Index.Box className="title-main">
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="page-title"
                      >
                        Loan Report
                      </Index.Typography>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="table-list">
                <Index.Box className="grid-row sahay-multiple-main">
                  <Index.Box sx={{ width: 1 }} className="grid-main">
                    <Index.Box
                      display="grid"
                      className="multiple-row"
                      gridTemplateColumns="repeat(12, 1fr)"
                      gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                    >
                      {/* Search */}
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 4",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <PagesIndex.Search
                            className="search sahay-multiple-search"
                            onChange={(e) => requestSearch(e.target.value)}
                          >
                            <PagesIndex.StyledInputBase placeholder="Search" />
                          </PagesIndex.Search>
                        </Index.Box>
                      </Index.Box>

                      {/* FID */}
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 4",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            className="multiple-autocomplet-control"
                            id="combo-box-demo"
                            options={data || []}
                            getOptionLabel={(option) => option?.FID?.toString()}
                            onChange={(value, newvalue) => {
                              setFilter(newvalue?.FID);
                            }}
                            filterOptions={(options, { inputValue }) => {
                              const inputLowerCase = inputValue?.toLowerCase();
                              const uniqueFamilyId = new Set();
                              return options?.filter((option) => {
                                const familyId =
                                  option?.FID?.toString()?.toLowerCase();
                                // Check unique
                                if (uniqueFamilyId?.has(familyId)) {
                                  return false;
                                }
                                // Check search
                                if (familyId?.includes(inputLowerCase)) {
                                  uniqueFamilyId?.add(familyId);
                                  return true;
                                }
                                return false;
                              });
                            }}
                            renderInput={(params) => (
                              <Index.TextField {...params} label="Fid" />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>

                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column common-date-picker-column"
                      >
                        <Index.Box className="sahay-multiple-input-main common-date-picker-custom date-input-box">
                          <Index.LocalizationProvider
                            dateAdapter={Index.AdapterDayjs}
                            sx={{ position: "absolute" }}
                          >
                            <Index.DemoContainer components={["DatePicker"]}>
                              <Index.DatePicker
                                // label="Application Receive Date"
                                name="DateOfLoan"
                                value={selectDateData}
                                onChange={(value) => {
                                  setSelectDateData(
                                    moment(value.$d).format("YYYY-MM-DD")
                                  );
                                }}
                                // renderInput={(params) => (
                                //   <Index.TextField
                                //       {...params}
                                //       label="Application Receive Date"
                                //   />
                                // )}
                                format="YYYY-MM-DD"
                                sx={{
                                  // overflowY: "hidden",
                                  // position: "relative",
                                  bottom: "4px",
                                  width: "100%",
                                }}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                              />
                            </Index.DemoContainer>
                          </Index.LocalizationProvider>
                        </Index.Box>
                      </Index.Box>

                      {/* {filterReportData?.length > 0 &&
                        searchedData?.length > 0 && (
                          <>
                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 4",
                                lg: "span 3",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="auth-input-main sahay-multiple-input-main">
                                <Index.Box
                                  Box
                                  className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                >
                                  <FileExcel
                                    apiData={excel}
                                    fileName={fileName}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 4",
                                lg: "span 3",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="sahay-multiple-input-main">
                                <Index.Box
                                  Box
                                  className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                >
                                  <Index.Button onClick={handlePrint}>
                                    Print
                                  </Index.Button>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </>
                        )} */}
                    </Index.Box>
                  </Index.Box>
                </Index.Box>

                <Index.TableContainer
                  sx={{ maxHeight: 180 }}
                  component={Index.Paper}
                  className="table-container user-master-container scroll-table"
                >
                  <Index.Table
                    stickyHeader
                    aria-label="sticky table"
                    className="table-design-main barge-table multiple-tablelist-table"
                  >
                    <Index.TableHead className="user-master-head">
                      <Index.TableRow className="user-master-tr">
                        <Index.TableCell className="user-master-th">
                          Fid
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Applicant Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Benificiary name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Moholla Name
                        </Index.TableCell>

                        <Index.TableCell className="user-master-th">
                          Area
                        </Index.TableCell>

                        <Index.TableCell className="user-master-th">
                          Mobile
                        </Index.TableCell>

                        <Index.TableCell
                          // className="user-master-th"
                          className="user-sahay-td"
                          onClick={() => handleSort("DateOfLoan")}
                        >
                          Date Of Loan
                          {sortColumn === "DateOfLoan" &&
                            (sortDirection === "asc" ? (
                              <SwapVertIcon
                                className="swap-icon user-sahay-td-svg"
                                fontSize="small"
                              />
                            ) : (
                              <SwapVertIcon
                                className="swap-icon user-sahay-td-svg"
                                fontSize="small"
                              />
                            ))}
                        </Index.TableCell>

                        <Index.TableCell className="user-master-th">
                          Loan Amount
                        </Index.TableCell>

                        <Index.TableCell className="user-master-th">
                          Disbursed Amount
                        </Index.TableCell>

                        <Index.TableCell className="user-master-th">
                          Due
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Recovery
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Partically Close
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Balance
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Over Due
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Action
                        </Index.TableCell>
                      </Index.TableRow>
                    </Index.TableHead>
                    <Index.TableBody className="user-master-tbody">
                      {pageData?.length ? (
                        pageData?.map((data, index) => {
                          return (
                            <Index.TableRow
                              className="user-master-tr"
                              key={index}
                              // onClick={() => handleSahayApplicationView(data)}
                              sx={{ cursor: "pointer" }}
                            >
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-role-name">
                                  {data?.FID || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-details-name">
                                  {data?.ApplicantName || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-email-name">
                                  {data?.BeneficiaryName || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.MohollaName || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.Area || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.Mobile || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.DateOfLoan || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.LoanAmount || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.DisbursedAmount || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.Due || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.Recovery || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.ParticallyCloseAmount || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.Balance || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.OverDue || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {/* {rollPermissionData?.permissionArray?.includes(
                                    "User Master_view"
                                  ) || rollPermissionNameData === "admin" ? ( */}
                                  <>
                                    <Index.IconButton
                                      onClick={() => handleLoanView(data)}
                                    >
                                      <Index.Visibility className="muiico-view" />
                                    </Index.IconButton>
                                  </>
                                  {/* ) : (
                                    ""
                                  )} */}
                                </Index.Box>
                              </Index.TableCell>
                            </Index.TableRow>
                          );
                        })
                      ) : (
                        <PagesIndex.NoRecordFound colSpan={16} />
                      )}
                    </Index.TableBody>
                  </Index.Table>
                </Index.TableContainer>
                {filterReportData?.length > 0 && searchedData?.length > 0 && (
                  <Index.Box className="multiple-total-text-main">
                    <Index.Typography className="multiple-total-text">
                      Total Loan Amount :
                      {searchedData.length > 0 &&
                        searchedData?.reduce((acc, curr) => {
                          let total;
                          total = acc + curr?.LoanAmount;
                          return total;
                        }, 0)}
                    </Index.Typography>
                  </Index.Box>
                )}

                <Index.Box className="pagination-design flex-end">
                  <RowPerPageDropdown
                    rowPerPage={rowPerPage}
                    setRowPerPage={setRowPerPage}
                  />
                  <Index.Stack spacing={2}>
                    <Pagination
                      fetchData={searchedData}
                      setPageData={setPageData}
                      pageData={pageData}
                      rowPerPage={rowPerPage}
                    />
                  </Index.Stack>
                </Index.Box>

                <Index.Box sx={{ display: "none" }}>
                  <PrintReport
                    componentRef={componentRef}
                    tableData={excel}
                    reportName={[{ type: "SahayWiseReport" }]}
                  />
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </>
      )}
    </>
  );
}
